module.exports = __webpack_public_path__ + "img/tee-white-01.ac049091.jpg";